module.exports = __webpack_public_path__ + "static/media/cabrio.7882d91b.svg";